import { borderWidths, colors, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

export interface DividerProps {
  marginBottom?: keyof typeof spacing;
  marginTop?: keyof typeof spacing;
}

export const Divider = styled.hr<DividerProps>`
  ${({ marginBottom = 'medium', marginTop = 'small' }) => css`
    width: 100%;
    margin-top: ${spacing[marginTop]};
    margin-bottom: ${spacing[marginBottom]};
    border: ${borderWidths.thin} solid ${colors.neutral_extra_light};
  `}
`;
